module.exports = __webpack_public_path__ + "static/media/JIBSWAP-logo-mark-full-color.bff66e6a.svg";